function k({
  prefixId: o,
  lexer: s,
  description: n
}) {
  const t = {
    type: "footnotes",
    raw: n,
    items: []
  };
  return {
    name: "footnote",
    level: "block",
    childTokens: ["content"],
    tokenizer(e) {
      s.hasFootnotes || (this.lexer.tokens.push(t), s.tokens = this.lexer.tokens, s.hasFootnotes = !0, t.items = []);
      const r = /^\[\^([^\]\n]+)\]:(?:[ \t]+|[\n]*?|$)([^\[\n]*?(?:\n|$)(?:[\n]*?[ ]{4,}[^\[\n]*)*)/.exec(
        e
      );
      if (r) {
        const [i, a, c = ""] = r;
        let f = c.split(`
`).reduce((d, h) => d + `
` + h.replace(/^(?:[ ]{4}|[\t])/, ""), "");
        const l = f.trimEnd().split(`
`).pop();
        f += // add lines after list, blockquote, codefence, and table
        l && /^[ \t]*?[>\-\*][ ]|[`]{3,}$|^[ \t]*?[\|].+[\|]$/.test(
          l
        ) ? `

` : "", f += `<a href="#${o}ref-${encodeURIComponent(
          a
        )}" data-${o}backref aria-label="Back to reference ${a}">↩</a>`;
        const u = {
          type: "footnote",
          raw: i,
          label: a,
          content: this.lexer.blockTokens(f)
        };
        return t.items.push(u), u;
      }
    },
    renderer() {
      return "";
    }
  };
}
function $(o, s = !1) {
  return {
    name: "footnoteRef",
    level: "inline",
    tokenizer(n) {
      const t = /^\[\^([^\]\n]+)\]/.exec(n);
      if (t) {
        const [e, r] = t;
        return {
          type: "footnoteRef",
          raw: e,
          label: r
        };
      }
    },
    renderer({ label: n }) {
      const t = encodeURIComponent(n);
      return `<sup><a id="${o}ref-${t}" href="#${o + t}" data-${o}ref aria-describedby="${o}label">${s ? `[${n}]` : n}</a></sup>`;
    }
  };
}
function p(o) {
  return {
    name: "footnotes",
    renderer({ raw: s, items: n = [] }) {
      if (n.length === 0)
        return "";
      const t = n.reduce((r, { label: i, content: a }) => {
        let c = `<li id="${o + encodeURIComponent(i)}">
`;
        return c += this.parser.parse(a), c += `</li>
`, r + c;
      }, "");
      let e = `<section class="footnotes" data-footnotes>
`;
      return e += `<h2 id="${o}label" class="sr-only">${s.trimEnd()}</h2>
`, e += `<ol>
${t}
</ol>
`, e += `</section>
`, e;
    }
  };
}
function m(o = {}) {
  const {
    prefixId: s = "footnote-",
    description: n = "Footnotes",
    refMarkers: t
  } = o, e = { hasFootnotes: !1, tokens: [] };
  return {
    extensions: [
      k({ prefixId: s, lexer: e, description: n }),
      $(s, t),
      p(s)
    ],
    walkTokens(r) {
      e.tokens.indexOf(r) === 0 && r.type === "footnotes" && (e.tokens.push(e.tokens.shift()), e.hasFootnotes = !1);
    }
  };
}
export {
  m as default
};
